import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import { useFinance } from "../FinanceContext";
import { MONTHS } from "../data/seedData";
import { sumTo } from "../data/model";

/** Top strip of headline figures shown at the top of every finance page. */
export function AnnualBar({ extra }: { extra?: [string, string][] }) {
  const { model, fmt, selMonth, locks } = useFinance();
  let approved = 0;
  let ytdA = 0;
  model.items.forEach((it) => {
    approved += it.approved;
    ytdA += sumTo(it.actual, selMonth);
  });
  const lockedCount = locks.filter(Boolean).length;
  const items: [string, string][] = [
    ["Annual Approved Budget", fmt(approved)],
    ["Remaining Budget", fmt(approved - ytdA)],
    ["Reporting Month", MONTHS[selMonth] ?? ""],
    ["Frozen Periods", lockedCount + " / 12 months"],
    ...(extra ?? []),
  ];
  return (
    <Paper
      variant="outlined"
      sx={{
        display: "flex",
        flexWrap: "wrap",
        gap: 3,
        alignItems: "center",
        borderLeft: 4,
        borderLeftColor: "primary.main",
        px: 2,
        py: 1.25,
        mb: 2,
      }}
    >
      {items.map(([label, value]) => (
        <Box key={label}>
          <Typography
            variant="caption"
            color="text.secondary"
            sx={{ fontWeight: 700, textTransform: "uppercase" }}
          >
            {label}
          </Typography>
          <Typography sx={{ fontWeight: 800, fontSize: 16, mt: 0.25 }}>{value}</Typography>
        </Box>
      ))}
    </Paper>
  );
}
